/**
 * Baseline attachment caps mirrored by `apps/api` upload validation (`UPLOAD_PURPOSE_CONFIG`).
 */
export const DM_ATTACHMENT_BASE_MAX_BYTES = 50 * 1024 * 1024;
export const CONV_MEDIA_BASE_MAX_BYTES = 1_337_000_000;
/** Insider scalable ceiling (conversation media & DM attachments, decimal GB). */
export const INSIDER_DM_CONV_MAX_BYTES = 4_200_000_000;
/** Lifetime Founder: `founder` entitlement with lifetime billing (decimal GB). */
export const FOUNDER_LIFETIME_DM_CONV_MAX_BYTES = 9_001_000_000;
/**
 * E2E upload purposes. `space_identity_media` is an encrypted Space logo or
 * banner for `encryptIdentity` Spaces; it is bound to one Space at request time.
 */
export const E2E_UPLOAD_PURPOSES = ['conv_media', 'space_identity_media'];
/** Cap for an encrypted Space logo/banner blob (the client downscales first). */
export const SPACE_IDENTITY_MEDIA_MAX_BYTES = 10 * 1024 * 1024;
/** Content types an encrypted Space logo/banner may declare (pre-encryption). */
export const SPACE_IDENTITY_MEDIA_CONTENT_TYPES = ['image/webp', 'image/png', 'image/jpeg'];
/** Pixel bounds the client resizes Space identity images into before upload. */
export const SPACE_IDENTITY_MEDIA_DIMENSIONS = {
    logo: { maxWidth: 512, maxHeight: 512 },
    banner: { maxWidth: 1920, maxHeight: 480 },
};
/**
 * Effective max upload size for purposes that tier with Insider / Lifetime Founder grants.
 *
 * Ordering: Lifetime Founder entitlement beats Insider tier beats base caps.
 */
export function resolveScalableDmOrConvMaxUploadBytes(purpose, subscriptions, opts) {
    const base = purpose === 'conv_media' ? CONV_MEDIA_BASE_MAX_BYTES : DM_ATTACHMENT_BASE_MAX_BYTES;
    if (opts.isLifetime && opts.entitlements.includes('founder')) {
        return FOUNDER_LIFETIME_DM_CONV_MAX_BYTES;
    }
    if (subscriptions.includes('insider')) {
        return INSIDER_DM_CONV_MAX_BYTES;
    }
    return base;
}
//# sourceMappingURL=media-upload-limits.js.map